import { formatMoney } from '../../../helpers/utils'
import { effectiveLocationWithAllowedLocation, formatActivityName } from '../../../helpers/utils'
import dayjs from 'dayjs'
import { ACTIVITY_STATUS_OPTIONS } from '../constants/ClientDashboardConst'

export const buildClientCsvFile = (data, clientData, startDate, endDate) => {
  let rows = []

  // ====== ENCABEZADO ======

  rows.push(['Reporte:', 'Actividades de cliente'])
  rows.push(['Cliente:', `${clientData.db_ref} - ${clientData.customer_name_db_ref}`])
  rows.push([
    'Fecha de reporte:',
    `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`
  ])
  rows.push([''])

  // ====== TABLA DE ACTIVIDADES ======

  const headers = [
    'FECHA Y HORA',
    'USUARIO',
    'ACTIVIDAD',
    'CÓDIGO DE ACTIVIDAD',
    'MONTO',
    'DENTRO DE GEOCERCA',
    'LATITUD',
    'LONGITUD',
    'ESTADO'
  ]

  rows.push(headers)

  data?.forEach((activity) => {
    rows.push([
      dayjs(activity.created_date).format('DD/MM/YYYY, h:mm:ss A') || '-',
      `${activity.salesman_db_ref} - ${activity.salesman_name}`,
      activity.activity_name ? formatActivityName(activity.activity_name) : '-',
      activity.activity_uid || '-',
      activity.total ? formatMoney(activity.total || 0) : '-',
      effectiveLocationWithAllowedLocation(
        activity.effective_location,
        activity.has_allowed_location
      ),
      activity.latitude || 0,
      activity.longitude || 0,
      activity.status ? handleStatus(activity.status) : 'ENVIADO'
    ])
  })

  return rows
}

const handleStatus = (activityStatus) => {
  const statusKey = activityStatus === 'send' ? 'sent' : activityStatus
  const option = ACTIVITY_STATUS_OPTIONS[statusKey] ?? ACTIVITY_STATUS_OPTIONS.received
  return option.label
}
